import api from '@/helpers/api'
import { createNamespacedHelpers } from 'vuex'
export const { mapState, mapMutations, mapActions } = createNamespacedHelpers('program')

import Utils from "@/helpers/utils.js";

export default {
  namespaced: true,
  state: {
    programs: [],
  },
  mutations: {
    setProgram: (state, data) => { state.programs = Utils.sortData(data) }
  },
  actions: {
    getPrograms: async ({commit}) => {
      try {
        const response = await api.get('program/list')
        // console.log("programs :", response.data)
        commit('setProgram', response.data)
      } catch (e) {
        console.error('[axios] getPrograms :', e.message)
      }
    }
  }
}